import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { getMyTickets, getPracticeTickets } from "api/user";
import Badge from "components/common/Badge";
import SubHeader from "components/common/SubHeader";
import useRefreshCallback from "hooks/useRefreshCallback";

const MyTicket = () => {
    const [regularTickets, setRegularTickets] = useState([]);
    const [practiceTickets, setPracticeTickets] = useState([]);

    const fetchAndSyncTickets = async () => {
        const [regular, practice] = await Promise.all([
            getMyTickets().then((r) => r ?? []),
            getPracticeTickets(),
        ]);
        setRegularTickets(regular || []);
        setPracticeTickets(practice || []);
    };

    useRefreshCallback(fetchAndSyncTickets);

    useEffect(() => {
        fetchAndSyncTickets();
    }, []);

    const visibleRegularTickets = regularTickets.filter(
        (ticket) => ticket.status !== "CANCELLED"
    );

    const totalCount = visibleRegularTickets.length + practiceTickets.length;


    return (
        <div className="page-myticket">
            <SubHeader title="보유 수강권" />
            <SubHeader title="보유 수강권" />
            <p className="font-text3">
                보유 수강권{" "}
                <span className="font-purple">{totalCount}개</span>
              
            </p>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "25px",
                }}
            >
            
                {totalCount === 0 && (
                    <p className="font-text3">보유 수강권이 없습니다.</p>
                )}
                {visibleRegularTickets.map((ticket) => (
                    <TicketCard key={`r-${ticket.id}`} ticket={ticket} />
                ))}
                {practiceTickets.map((ticket) => (
                    <PracticeTicketCard key={`p-${ticket.id}`} ticket={ticket} />
                ))}
            </div>
        </div>
    );
};

export default MyTicket;

const TicketCard = ({ ticket }) => {
    const status = () => {
        switch (ticket.status) {
            case "UNUSED": // 사용 가능
                return "green";
            case "EXPIRED": 
            case "FULLY_USED":// 만료, 사용 완료 
                return "black";
            case "CANCELLED": // 취소
                return "red";
            default:
                return "purple";
        }
    };
    return (
        <div className={`ticket-card ${status() === 'black' ? 'ticket-card__disabled':""}`}>
            <div className="ticket-header">
                <h2 className="title">{ticket.lesson_product_name}</h2>
                <Badge text={ticket.status_display} 
                        type={'solid'}
                        color={status()}
                />
            </div>

            <p className="ticket-info">
                <span>생성날짜</span>
                <span>{dayjs(ticket.created_at).format("YYYY-MM-DD")}</span>
            </p>
            {ticket.valid_until !== null && (
                <p className="ticket-info">
                    <span>유효기간</span>{" "}
                    <span>{ticket.valid_until + "까지"}</span>
                </p>
            )}
            <p className="ticket-info">
                <span>이론수업</span>{" "}
                <span>
                    {ticket.lesson_progress.theory_completed
                        ? "완료"
                        : "미완료"}
                </span>
            </p>

            <div className="ticket-progress">
                <div className="ticket-progress-bar">
                    <div
                        className="ticket-progress-bar-fill"
                        style={{
                            width: `${
                                (ticket.sessions_used / ticket.sessions_total) *
                                100
                            }%`,
                        }}
                    ></div>
                </div>
                <p className="ticket-count">
                    <span> 잔여 횟수 {ticket.sessions_remaining}회</span>
                    <span>{ticket.sessions_total}회</span>
                </p>
            </div>
        </div>
    );
};

const PracticeTicketCard = ({ ticket }) => {
    const statusLabel = (() => {
        if (!ticket.is_active) return "취소됨";
        if (ticket.is_valid) return "사용중";
        if (ticket.remaining_sessions === 0) return "소진";
        return "기간만료";
    })();
    const progressPct =
        ticket.sessions_total > 0
            ? (ticket.sessions_used / ticket.sessions_total) * 100
            : 0;
    return (
        <div className="ticket-card">
            <div className="ticket-header">
                <h2 className="title">프리미엄 트레이닝</h2>
                <div className="ticket-status">{statusLabel}</div>
            </div>

            <p className="ticket-info">
                <span>생성날짜</span>
                <span>{dayjs(ticket.created_at).format("YYYY-MM-DD")}</span>
            </p>
            <p className="ticket-info">
                <span>유효기간</span>{" "}
                <span>{ticket.valid_until + "까지"}</span>
            </p>

            <div className="ticket-progress">
                <div className="ticket-progress-bar">
                    <div
                        className="ticket-progress-bar-fill"
                        style={{ width: `${progressPct}%` }}
                    ></div>
                </div>
                <p className="ticket-count">
                    <span> 잔여 횟수 {ticket.remaining_sessions}회</span>
                    <span>{ticket.sessions_total}회</span>
                </p>
            </div>
        </div>
    );
};
